import React from "react";

import { Permission } from "~/models/dto";

import type { MonitorCheckStatusConfiguredSilencingRule } from "../../../../../../common/openapi";
import { usePermissions } from "../../../../../../common/use-permissions";

import { ActiveRuleAlert } from "./common/active-rule-alert";
import { AppliesTo } from "./common/applies-to";
import { CannotUnmuteAlert } from "./common/cannot-unmute-alert";
import { InternalLiveRuleTiming } from "./common/internal-live-rule-timing";
import { SilencingNote } from "./common/silencing-note";
import { UnmuteFooter } from "./common/unmute-footer";

export function InternalLiveWithoutSelector({ rule }: { rule: MonitorCheckStatusConfiguredSilencingRule }) {
	const permissions = usePermissions();
	const hasUnmutePermissions = permissions?.hasSystemPermission(Permission.DeleteSilencingRules) ?? false;

	return (
		<>
			<div className="drawer-body flex flex-col gap-6">
				<section className="flex flex-col gap-4">
					<ActiveRuleAlert />
					{!hasUnmutePermissions && <CannotUnmuteAlert />}
				</section>
				<InternalLiveRuleTiming rule={rule} />
				<SilencingNote note={rule.note} />
				<AppliesTo />
			</div>
			{hasUnmutePermissions && <UnmuteFooter rule={rule} />}
		</>
	);
}
